<template>
    <div :class="[ responsive ? 'table-responsive' : ''] ">
        <table class="table" :class="init_table_class" :style="with_action_bar && noOfRecords > 0 && noOfRecords < 3 ? 'min-height:300px;' : ''">
            <thead :class="thead_class">
            <slot name="thead" :locale="locale"/>
            </thead>
            <tbody :class="tbody_class">
            <slot :table_data="table_data" :hasRecords="hasRecords"/>
            </tbody>
        </table>
        <modal init_id="ListModal"
               :init_fields="{}"
               :init_title="modal_lang.ListModal ? modal_lang.ListModal.modalTitle : ''"
               ref="ListModal"
        >
            <template slot="body" slot-scope="body">
                {{ modal_lang.ListModal ? modal_lang.ListModal.modalMessage : '' }}
            </template>
            <template slot="footer" slot-scope="footer">
                <div class="modal-footer">
                    <button type="button" class="btn btn-white" data-dismiss="modal">
                        {{ modal_lang.ListModal ? modal_lang.ListModal.modalCancel : '' }}
                    </button>
                    <button type="button" class="btn btn-blue" @click="deleteRecord">
                        {{ modal_lang.ListModal ? modal_lang.ListModal.modalSubmit : '' }}
                    </button>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
    import deleteModal from "../../mixins/deleteModal";

    export default {
        mixins: [deleteModal],
        data() {
            return {
                table_data: this.init_data ? JSON.parse(this.init_data) : {},
                additional: this.init_additional,
                thead_class: this.init_thead_class,
                tbody_class: this.init_tbody_class,
                locale: window.locale,
                with_action_bar: false,
            }
        },
        props: {
            element_id: {
                required: false,
                type: String,
                default: null
            },
            url: {
                required: true,
                type: String,
            },
            responsive: {
                type: Boolean,
                default: true,
            },
            init_table_class: {
                type: String,
                default: 'table-style1 table-hover table-striped',
            },
            init_data: {
                default: null,
                required: false,
            },
            init_thead_class: {
                default: () => {
                    return [];
                },
            },
            init_tbody_class: {
                default: () => {
                    return [];
                },
            },
            extract_hook_success_callback: {
                type: Boolean,
                default: false,
            },
            extract_hook_fail_callback: {
                type: Boolean,
                default: false,
            },
            disable_filters: {
                type: Boolean,
                required: false,
                default: false,
            },
            plain_list_page_id: {
                type: String,
                required: false,
                default: null,
            }
        },
        beforeDestroy() {
			window.eventHub.$off('extract-table-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    return this.table_data;
                } else {
                    return '';
                }
            });
			window.eventHub.$off('plain-list-reload-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            });
			window.eventHub.$off('set-table-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    return this.table_data;
                } else {
                    return '';
                }
            });
        },
        mounted() {
            if (this.url.includes('?')) {
                this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
            } else {
                this.fetchData(this.url + this.$store.getters.query);
            }

			window.eventHub.$on('extract-table-data', (element_id) => {
			    if (_.isUndefined(element_id)) {
                    window.eventHub.$emit('pull-table-data', this.table_data);
                } else {
                    if (element_id == this.element_id) {
                        window.eventHub.$emit('pull-table-data', this.table_data, element_id);
                    }
                }
            });
			window.eventHub.$on('plain-list-reload-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            });
			window.eventHub.$on('set-table-data', (data, element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    this.table_data.data = data;
                }
            });
        },
        methods: {
            fetchData(url) {
                let self = this;
                self.$store.commit('setSubmitting', true);

                let successCallback = (response) => {
                    self.table_data = response.data;
                    self.$store.commit('setSubmitting', false);
                    if (self.extract_hook_success_callback) {
                        if (_.isNull(this.element_id)) {
                            window.eventHub.$emit('extract-table-data');
                        } else {
                            window.eventHub.$emit('extract-table-data', self.element_id);
                        }
                    }
                    this.$nextTick(() =>{
                        if (document.getElementsByClassName('table-actions').length > 0) {
                            self.with_action_bar = true;
                        }
                    });
                };

                let failCallback = (error) => {
                    self.$store.commit('setNotificationType', 'danger');
                    self.$store.commit('setNotification', error.response.data.message);
                    self.$store.commit('setSubmitting', false);
                    if (self.extract_hook_fail_callback) {
                        if (_.isNull(this.element_id)) {
                            window.eventHub.$emit('extract-table-data');
                        } else {
                            window.eventHub.$emit('extract-table-data', self.element_id);
                        }
                    }
                }
                if (url != '' && self.editPlainListPageId) {
                    if (url.includes('?')) {
                        url += '&_t=' + new Date().getTime();
                    } else {
                        url += '?_t=' + new Date().getTime();
                    }
                    this.$root.ajax_get(url, successCallback, failCallback);
                }
            },
            search(keyword) {
                this.$store.commit('setFilterKeyword', keyword);
            },
            sort(field) {
                this.$store.commit('setFilterSort', field);
                this.$store.commit('toggleFilterOrder')
            },
        },
        watch: {
            filter() {
                if (!this.disable_filters) {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            },
            url() {
                if (this.url != '') {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&') + '&page=' + this.page);
                    } else {
                        this.fetchData(this.url + this.$store.getters.query + '&page=' + this.page);
                    }
                }
            }
        },
        computed: {
            noOfRecords() {
                return this.table_data.data ? this.table_data.data.length : 0;
            },
            hasRecords() {
                return this.table_data.data ? this.table_data.data.length : false;
            },
            filter() {
                return this.$store.getters.query;
            },
            editPlainListPageId() {
                if(this.plain_list_page_id != null && this.plain_list_page_id != ''){
                    this.$root.unique_page_id = this.plain_list_page_id;
                }
                else{
                    this.$root.unique_page_id = '';
                }

                return true;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Table/PlainList.vue